<template>
  <div class="bordered-layout">
    <!-- FILE FILTER -->
    <b-card no-body class="mb-1">
      <b-card-body>
        <div class="row">
          <div class="col-12 col-md-3">
            <b-form-group label="Từ khóa" label-for="searchInput">
              <b-input-group>
                <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Tên,file"
                  @keyup.enter="updateSearchQuery" />
                <b-input-group-append>
                  <b-button variant="primary" @click="searchFiles">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Từ ngày" label-for="startDate">
              <div class="input-group">
                <flat-pickr ref="startDateRef" v-model="startDate" class="form-control" :config="configDate"
                  placeholder="Từ ngày" @on-change="searchFiles" @on-close="searchFiles" />
                <div class="input-group-append">
                  <button v-if="!startDate" class="input-group-text" type="button" @click.prevent="openStartDate">
                    <feather-icon icon="CalendarIcon" />
                  </button>
                  <button v-if="startDate" class="input-group-text" type="button" @click.prevent="clearStartDate">
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Đến ngày" label-for="endDate">
              <div class="input-group">
                <flat-pickr ref="endDateRef" v-model="endDate" class="form-control" :config="configDate"
                  placeholder="Đến ngày" @on-change="searchFiles" @on-close="searchFiles" />
                <div class="input-group-append">
                  <button v-if="!endDate" class="input-group-text" type="button" @click.prevent="openEndDate">
                    <feather-icon icon="CalendarIcon" />
                  </button>
                  <button v-if="endDate" class="input-group-text" type="button" @click.prevent="clearEndDate">
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- FILE UPLOAD -->
    <b-card no-body class="mb-1">
      <file-upload ref="uploadDaletFileRef" class="m-1" :show-sync-dalet="false" :sync-dalet="true" :auto-upload="true"
        :only-sync-audio="true" :remove-file-after-success="true" :close-modal-after-all-success="false"
        text-upload-button="Tải file vào dalet" input-id="input-upload-mam-file">
        <template #fileupload-right />
      </file-upload>
    </b-card>

    <!-- table -->
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <vue-good-table ref="tableGood" :columns="columns" :rows="itemsData" :rtl="direction" :search-options="{
          enabled: false,
          externalQuery: searchQuery
        }" :select-options="{
  enabled: false,
  selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
  selectionInfoClass: 'custom-class',
  selectionText: 'dòng được chọn',
  clearSelectionText: 'xóa',
  disableSelectInfo: false, // disable the select info panel on top
  selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
}" :pagination-options="{
  enabled: true,
  perPage: pageLength
}" :sort-options="{
  enabled: false,
}" @on-selected-rows-change="onSelectedRowChange" @on-page-change="onPageChange">
          <template slot="selected-row-actions">
            <b-button size="sm" variant="outline-primary" @click="addSelectedFileToEditor">
              <feather-icon icon="PlusIcon" /> Chèn các file đã chọn
            </b-button>
          </template>
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <b-link v-if="props.column.field === 'file'" class="font-weight-bold" @click="previewFile(props.row)">
              {{ props.row.file }}
            </b-link>
            <!-- Column: Created At -->
            <span v-else-if="props.column.field === 'created_at'">
              {{ convertDate(props.row.created_at) }}
            </span>
            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'" class="text-center">
              <!-- <a
                :href="props.row.file_path"
                size="sm"
                class="btn btn-sm btn-outline-primary"
                download
                target="_new"
              >
                <feather-icon icon="DownloadIcon" /> Tải về
              </a> -->
              <button size="sm" class="btn btn-sm btn-outline-primary" :disabled="props.row.downloaded"
                @click="downloadFile(props.row)">
                <feather-icon icon="DownloadIcon" /> Tải về
              </button>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap p-1">
              <div class="d-flex align-items-center">
                <span class="text-nowrap ">
                  Hiển thị 1 đến
                </span>
                <b-form-select v-model="pageLength" :options="['10', '20', '30', '50']" class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                <span class="text-nowrap"> của {{ props.total }} mục </span>
              </div>
              <div>
                <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                  prev-class="prev-item" next-class="next-item" class="m-0"
                  @input="(value) => props.pageChanged({ currentPage: value })">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card>
    </b-overlay>

    <!-- MODAL SHOW PREVIEW -->
    <b-modal id="showPreview" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop hide-footer
      title="Xem thử">
      <template v-if="filePreview">
        <div v-if="filePreview.type === 'image'" class="h-50 p-2">
          <img :src="filePreview.full_path ? filePreview.full_path : filePreview.file_local" class="img-fluid">
        </div>
        <div v-if="filePreview.type === 'audio'" class="h-50 p-2">
          <audio width="100%" :src="filePreview.full_path ? filePreview.full_path : filePreview.file_local" autoplay
            controls type="audio/*" :style="{ width: '100%' }" />
        </div>
        <div v-if="filePreview.type === 'video'" class="video p-1">
          <video width="100%" poster="/img/poster.gif"
            :src="filePreview.full_path ? filePreview.full_path : filePreview.file_local" autoplay controls
            type="video/*" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

import {
  BOverlay, BCard, BCardBody, BButton, BFormInput, BInputGroup, BInputGroupAppend,
  BFormGroup, BFormSelect, BPagination, BLink,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { ref, watch } from '@vue/composition-api';
import { VueGoodTable } from 'vue-good-table'
import { insertFileToEditor } from '@/libs/initTinymce';
import store from '@/store/index'
import { formatDate } from '@/libs/helper';
// import { showToast } from '@/@core/utils/utils';
import { showToast } from '@/@core/utils/utils';
import FileUpload from './components/FileUpload.vue';
import useFileManager from './useFileManager';

export default {
  components: {
    FileUpload,
    VueGoodTable,
    BOverlay,
    BLink,
    BCard,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BInputGroup,
    BCardBody,
    BInputGroupAppend,
    flatPickr,
  },
  data() {
    return {
      localSearchQuery: '',
      pageLength: 10,
      dir: false,
      columns: [
        // {
        //   label: '#',
        //   field: 'id',
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        // },
        {
          label: 'Tên file',
          field: 'file',
        },
        {
          label: 'Thời gian',
          field: 'created_at',
        },
        {
          label: 'Tải về',
          field: 'action',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      selectedRows: [],
      searchTerm: '',
    }
  },
  setup() {
    const searchQuery = ref('');
    const startDate = ref('');
    const endDate = ref('');
    const itemsData = ref([]);
    const filePreview = ref(null);
    const {
      loading,
      autoFetchFiles,
      configDate,
    } = useFileManager();

    const fetchFilesDalet = () => {
      loading.value = true;
      store
        .dispatch('files/fetchFilesDalet', {
          keyword: searchQuery.value,
          start_date: startDate.value,
          end_date: endDate.value,
        })
        .then((res) => {
          loading.value = false;
          if (res.status === 200) {
            if (res.data.code === 200) {
              // console.log('res.data', res.data);
              itemsData.value = Array.isArray(res.data.data) ? res.data.data : [];
            }
          }
        });
    };

    const downloadFile = async (file) => {
      // console.log(file);
      try {
        if (!file.downloaded) {
          file.downloaded = true
          console.log(`${file.name}.${file.extension}`);
          const data = await fetch(file.file_path)
          const blob = await data.blob()
          const objectUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.setAttribute('href', objectUrl)
          link.setAttribute('download', `${file.name}.${file.extension}`)
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      } catch (error) {
        showToast('Lỗi tải file: Không tìm thấy file');
      }
    }

    watch([searchQuery, startDate, endDate], () => {
      fetchFilesDalet();
    });

    return {
      loading,
      itemsData,
      fetchFilesDalet,
      autoFetchFiles,
      searchQuery,
      startDate,
      endDate,
      configDate,
      filePreview,
      downloadFile,
    }
  },
  computed: {

    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  // watch: {
  //   '$store.state.files.show_all_category': function () {
  //     this.fetchFilesDalet();
  //   },
  // },
  mounted() {
    if (this.autoFetchFiles) {
      this.fetchFilesDalet();
    }
  },
  methods: {
    updateSearchQuery() {
      this.searchQuery = this.localSearchQuery
    },
    onPageChange(params) {
      this.currentPage = params.currentPage;
    },
    clearStartDate() {
      this.startDate = '';
    },
    clearEndDate() {
      this.endDate = '';
    },
    openStartDate() {
      this.$refs.startDateRef.$el.focus();
    },
    openEndDate() {
      this.$refs.endDateRef.$el.focus();
    },
    searchFiles() {
      this.fetchFilesDalet();
    },
    addFileToEditor(item) {
      this.$store.dispatch('files/setState', {
        show_file_manager: false,
        auto_fetch_files: false,
        // file_from_editor: false,
        file_info: item,
      });
      insertFileToEditor(item);
    },
    onSelectedRowChange() {
      this.selectedRows = this.$refs.tableGood.selectedRows;
    },
    addSelectedFileToEditor() {
      if (this.selectedRows.length) {
        this.selectedRows.forEach(file => {
          this.addFileToEditor(file);
        });
      }
    },
    convertDate(date) {
      return formatDate(date)
    },
    previewFile(file) {
      this.filePreview = file;
      console.log('this.filePreview', this.filePreview);
      this.$bvModal.show('showPreview');
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
